import React from 'react'

const CowriterSearchHeader = () => (
    <>
        <p>
            This page displays a list of your co-writers along with the number of songs you've written together, making
            it easier to track your collaborations at a glance.
        </p>
    </>
)

export default CowriterSearchHeader
